/* Utils */
import { generateSelectEntityById, generateSelectEntitiesByIdsList } from '../utils/generators/selectorGenerators';

export const selectAllContents = (state) => state.contents;

export const selectContentById = generateSelectEntityById(selectAllContents);

export const selectContentsListByIdsList = generateSelectEntitiesByIdsList(
  selectAllContents,
);
